'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createPredicate = function createPredicate(_ref, inputs) {
  var _ref2 = _slicedToArray(_ref, 2),
      test = _ref2[0],
      errorMsg = _ref2[1];

  return function (a, inputs) {
    return test(a, inputs) ? null : errorMsg;
  };
};
var createPredicates = R.map(createPredicate);
var runPredicates = function runPredicates(_ref3, data) {
  var _ref4 = _slicedToArray(_ref3, 2),
      input = _ref4[0],
      validations = _ref4[1];

  return R.map(function (predFn) {
    return predFn(input, data);
  }, createPredicates(validations, data));
};

var validate = R.compose(R.map(R.head), R.filter(R.length), function (data) {
  return R.map(function (dataItem) {
    return R.filter(R.identity, runPredicates(dataItem, data));
  }, data);
}, R.mergeWithKey(function (k, l, r) {
  return [l, r];
}));

var WithValidation = function WithValidation(rules) {
  return (0, _compose2.default)((0, _withState2.default)('errors', 'setErrors', {}), (0, _withState2.default)('formState', 'updateFormState', {}), (0, _mapProps2.default)(function (_ref5) {
    var formState = _ref5.formState,
        updateFormState = _ref5.updateFormState,
        errors = _ref5.errors,
        setErrors = _ref5.setErrors,
        onSubmitForm = _ref5.onSubmitForm,
        onFormError = _ref5.onFormError,
        onNextStep = _ref5.onNextStep,
        rest = _objectWithoutProperties(_ref5, ['formState', 'updateFormState', 'errors', 'setErrors', 'onSubmitForm', 'onFormError', 'onNextStep']);

    return _extends({
      onChange: function onChange(name, value) {
        return updateFormState(function (form) {
          return R.assocPath([name], value, form);
        });
      },
      setInitialState: function setInitialState(intialState) {
        return updateFormState(function (form) {
          return intialState;
        });
      },
      onBlur: function onBlur(name, value) {
        var _errors = validate(_defineProperty({}, name, value), _defineProperty({}, name, rules[name]));

        if (R.isEmpty(_errors)) {
          setErrors(R.omit(['' + name], errors));
        } else {
          setErrors(_extends({}, errors, _errors));
        }
      },
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        var activeRules = R.keys(rules).reduce(function (_rules, keyName) {
          if (e.target.querySelector('[name=' + keyName + ']') !== null) _rules[keyName] = rules[keyName];

          return _rules;
        }, {});

        var formData = R.keys(activeRules).reduce(function (form, keyName) {
          var formValue = R.path(['value'], e.target.querySelector('[name=' + keyName + ']'));

          switch (typeof formValue === 'undefined' ? 'undefined' : _typeof(formValue)) {
            case 'string':
              form[keyName] = R.trim(formValue);
              break;
            default:
              form[keyName] = formValue;
              break;
          }

          return form;
        }, {});
        var data = R.merge(formData, formState);
        var _errors = validate(data, activeRules);

        setErrors(_errors);

        if (R.isEmpty(_errors)) {
          onSubmitForm && onSubmitForm(data, onNextStep);
        } else onFormError && onFormError(data);
      },
      errors: errors
    }, rest);
  }));
};

exports.default = WithValidation;